export const availableKeysInDictionary = [
  'username',
  'action',
  'document',
  'date',
  'time',
  'entityname',
  'folder_id',
  'folder_name',
  'emails',
  'ip',
  'location',
  'permissions_before',
  'permissions_after',
  'city',
  'country',
  'group_role',
  'group_id',
  'organization_name',
  'organization_description',
  'organization_link',
  'organization_id',
  'prev_group_name',
  'documents_names',
  'documents_ids',
  'document_id',
  'email',
  'phone',
  'before',
  'after',
  'document_size',
  'note_text',
  'agreement_data',
  'confidential_date',
  'browser_version',
  'old_folder_name',
  'signing_data',
  'users',
  'watermark_enable',
  'addressee_name',
  'old_token',
  'entity_id',
  'phone_model',
  'full_name',
  'documents',
  'document_temp_link',
  'temp_link_url',
  'entity_name',
  'user_comment',
  'addressee_email',
  'chat_title',
  'user_id',
  'invite_email',
  'folder_names',
  'members_ids',
  'document_name',
  'old_folder_id',
  'role_name',
  'new_token',
  'room_id',
  'new_folder_id',
  'folder_ids',
  'first_name',
  'last_name',
  // 'transition_point',
  // 'group_name',
  'new_users'
];

export const keysAvailableToTranslate = [
  'name',
  'description',
  'first_name',
  'last_name',
  'custom_url',
  'agreement_enable',
  'agreement_file',
  'organization_name',
  'organization_description',
  'organization_link',
  'permissions',
  'date_format',
  'email',
  'phone_number',
  'tfa_enabled',
  'language'
]
